import { PlatformLocation } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-recurring-payments',
  templateUrl: './recurring-payments.component.html',
  styleUrls: ['./recurring-payments.component.scss']
})
export class RecurringPaymentsComponent implements OnInit {

  paymentFrequency: any;

  constructor(private router: Router, private loaderService: LoaderService, private storageService: StorageService,
    private location:PlatformLocation) {
    let paymentFrequencyString = this.storageService.getPaymentFrequency();
    if (paymentFrequencyString) {
      this.paymentFrequency = paymentFrequencyString;
    } else {
      router.navigateByUrl('/confirmation');
    }

    history.pushState(null, '', window.location.href);
    location.onPopState(() => {
      router.navigateByUrl('/home');
    });
  }

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }

}
